<template>
  <div class="terminology-component-container">
    <div
      class="term"
      v-html="flashcard.question"
    />
    <div
      :class="{ show: answered }"
      class="answer"
    >
      <div
        v-if="answered"
        v-html="definition"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    answered: {
      type: Boolean,
      default: false,
    },
    flashcard: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    definition() {
      return this.flashcard.answers[0].content;
    },
  },
};
</script>

<style lang='scss' scoped>
  .terminology-component-container {
    background: white;
    border-radius: 4px;
    box-shadow: 0 1px 3px 2px rgba(0,0,0,0.25);
    display: flex;
    flex-direction: column;
    margin: auto;
    max-width: rem-calc(600);

    .term {
      color: #354052;
      font-size: rem-calc(50);
      padding: rem-calc(32);
      text-align: center;

      :deep(img) {
        display: block;
        margin: auto;
        max-width: 100%;
        width: auto;
      }
    }

    .answer {
      background: #F9FAFC;
      border-radius: 0 0 4px 4px;
      border-top: 10px solid #e2e7ee;
      padding: rem-calc(16) rem-calc(32);

      &.show {
        padding: rem-calc(32);
        > div {
          font-size: rem-calc(20);
          text-align: left;
        }
      }

      > div {
        color: #354052;
        font-size: rem-calc(50);
        text-align: center;
      }
    }
  }
</style>
